let company = {
    companyName: "企业名称",
    enterCompanyName: "请输入企业名称",
    companyNumber: "企业编号",
    addCompany: "添加企业",
    companyDetail: "企业详情",

}

export default company
